(ns app.front.view.permit.inspections
  (:require [app.domain.inspection.model :as inspection-model]
            [app.front.entities :as entities]
            [app.front.ui :as ui]
            [app.front.ui.table :as ui-table]
            [app.front.view.inspections.add :as inspection-add]
            [app.front.view.inspections.edit :as inspection-edit]
            [app.front.view.inspections.events :as inspection-events]
            [core.front.event :refer [<sub >evt]]
            [re-frame.core-instrumented :as rf]
            [reagent.core :as r])
  (:require-macros [core.util.util :as util]))

(defn strikeout-if-cancelled [extractor]
  (fn [{state :domain/state :as entity}]
    [:span
     {:class (when (= state :inspection.state/cancelled) "line-through")}
     (extractor entity)]))

(defn on-update [execution inspection-id attr value]
  (>evt [:app.front.process/signal
         execution
         [:process.signal/update-inspection
          {:inspection-id inspection-id
           :attr          attr
           :value         value}]]))


(rf/reg-sub ::section-entities
  :<- [::entities/context]
  (fn [{:keys [entity-db] :as ctx} [_ section-id]]
    (->> (entities/find-entities ctx (-> entity-db
                                         (get section-id)
                                         :verdict.section/entities
                                         set))
         (filter some?)
         (sort-by :ordered/order))))


(defn view [{:keys                         [tr execution]
             {verdict-state :domain/state} :verdict
             :as                           props}
            {verdict-section-id :db/id}]
  (r/with-let [editor (fn [inspection _]
                        (let  [execution (:entity/parent inspection)]
                          [inspection-edit/editor
                           (-> props
                               (assoc :on-update     (partial on-update execution)
                                      :target-entity execution))
                           inspection]))]
    #_{:clj-kondo/ignore [:deprecated-var]}
    (let [can-edit? (inspection-model/verdict-states-for-editing verdict-state)
          ;; draft inspections are fetched after workspace-get, so :verdict.section/entities
          ;; may contain either entities *or* entity-ids, if the fetch has not finished by
          ;; the time rendering starts here -> special subscription that does not operate on
          ;; entity objects
          items     (<sub [::section-entities verdict-section-id])
          lang      (<sub [:language])]
      [:div.verdict-page.mt-6.mb-6 {:key (str verdict-section-id)}
       [:div.verdict-page__section.verdict-page__inspections
        [:h4 (tr [:verdict/inspections])]
        [ui-table/table-2
         (merge (util/mmap {:id                (str "verdict-section-table-" verdict-section-id)
                            :header+extractors [[:inspection/name
                                                 (strikeout-if-cancelled
                                                   #(inspection-model/inspection-name % lang))]
                                                [:inspection/description
                                                 (strikeout-if-cancelled
                                                   (comp ui/summarize-description
                                                         #(inspection-model/inspection-description % lang)))]]
                            :expand-component  (when can-edit? editor)}
                           items tr)
                (when can-edit?
                  {:on-reorder (partial inspection-events/on-reorder execution)}))]
        (when (and can-edit?
                   (<sub [:app.front.process/execution-signal-permitted?
                          [:process.signal/add-inspection (util/mmap verdict-section-id)]]))
          [:div.mt-3
           [inspection-add/add-component (util/mmap {:target-entity execution}
                                                    tr verdict-section-id)]])]])))
